var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.129,
    height: 41.129,
    viewBox: "0 0 41.129 41.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#cad9fc}.cls-3{fill:#e8edfc}.cls-4{fill:#fff}.cls-5{fill:#428dff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diamond_1_",
    "data-name": "diamond (1)",
    transform: "translate(-.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16942",
    fill: "#5496ce",
    d: "M47.473 115.983l-.816-.6-1.241-.919-4.216-3.1a2.215 2.215 0 0 0-1.09-.418l-.007-.007-.007.007a1.654 1.654 0 0 0-.185-.007H16.99a1.657 1.657 0 0 0-.185.007h-.014a2.216 2.216 0 0 0-1.09.418l-6.272 4.62a2.09 2.09 0 0 0-.85 1.81 2.059 2.059 0 0 0 .452 1.186l18.289 22.95a1.452 1.452 0 0 0 2.262 0l18.288-22.95a2.057 2.057 0 0 0 .452-1.186 2.09 2.09 0 0 0-.85-1.81zm0 0",
    "data-name": "Path 16942",
    transform: "translate(-7.883 -102.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16943",
    d: "M409.369 117.875h-5.477l-2.735-6.848a2.214 2.214 0 0 1 1.09.418l4.216 3.1 1.241.919.816.6a2.09 2.09 0 0 1 .85 1.81zm0 0",
    className: "cls-2",
    "data-name": "Path 16943",
    transform: "translate(-368.928 -102.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16944",
    d: "M364.575 117.875h-6.169l3.42-6.848h.014zm0 0",
    className: "cls-3",
    "data-name": "Path 16944",
    transform: "translate(-329.612 -102.109)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13689",
    "data-name": "Group 13689",
    transform: "translate(.692 8.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16945",
    d: "M322.586 110.944l-3.42 6.848-3.427-6.855h6.661a1.656 1.656 0 0 1 .185.007zm0 0",
    className: "cls-3",
    "data-name": "Path 16945",
    transform: "translate(-291.064 -110.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16946",
    d: "M264.23 117.8H256l4.8-6.855zm0 0",
    className: "cls-3",
    "data-name": "Path 16946",
    transform: "translate(-236.128 -110.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16947",
    d: "M205.866 110.941l-4.8 6.855-4.8-6.855zm0 0",
    className: "cls-3",
    "data-name": "Path 16947",
    transform: "translate(-181.192 -110.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16948",
    d: "M117.872 110.937l-3.427 6.855-3.421-6.848a1.657 1.657 0 0 1 .185-.007zm0 0",
    className: "cls-3",
    "data-name": "Path 16948",
    transform: "translate(-102.794 -110.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16949",
    d: "M16.791 111.027l-2.735 6.848H8.579a2.09 2.09 0 0 1 .85-1.81l6.272-4.62a2.216 2.216 0 0 1 1.09-.418zm0 0",
    className: "cls-3",
    "data-name": "Path 16949",
    transform: "translate(-8.575 -111.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16950",
    d: "M28.493 220.952a1.428 1.428 0 0 1-1.131-.542L9.074 197.46a2.059 2.059 0 0 1-.452-1.186H14.1zm0 0",
    className: "cls-2",
    "data-name": "Path 16950",
    transform: "translate(-8.617 -189.419)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16951",
    d: "M91.2 220.951l-14.4-24.677h6.169zm0 0",
    className: "cls-3",
    "data-name": "Path 16951",
    transform: "translate(-70.632 -180.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16952",
    d: "M275.876 196.273a2.057 2.057 0 0 1-.452 1.186l-18.288 22.95a1.429 1.429 0 0 1-1.131.542l5.182-8.877 2.015-3.462 4-6.855 3.2-5.484zm0 0",
    className: "cls-2",
    "data-name": "Path 16952",
    transform: "translate(-235.436 -180.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16953",
    d: "M332.991 196.273a1.754 1.754 0 0 1-.288.5l-12.188 15.3 2.015-3.462 4-6.855 3.2-5.484zm0 0",
    className: "cls-3",
    "data-name": "Path 16953",
    transform: "translate(-294.765 -180.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16954",
    d: "M82.974 117.875H76.8l2.735-6.848h.014zm0 0",
    className: "cls-2",
    "data-name": "Path 16954",
    transform: "translate(-70.631 -102.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16955",
    d: "M161.832 117.8h-8.226l3.427-6.855zm0 0",
    className: "cls-2",
    "data-name": "Path 16955",
    transform: "translate(-141.263 -102.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16956",
    d: "M264.23 196.273L256 220.95v-24.677zm0 0",
    className: "cls-3",
    "data-name": "Path 16956",
    transform: "translate(-235.436 -180.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16957",
    d: "M270.4 196.273l-3.2 5.484-4 6.855-7.2 12.338 8.226-24.677zm0 0",
    className: "cls-2",
    "data-name": "Path 16957",
    transform: "translate(-235.436 -180.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16958",
    d: "M161.832 196.273v24.677l-8.226-24.677zm0 0",
    className: "cls-2",
    "data-name": "Path 16958",
    transform: "translate(-141.263 -180.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16959",
    d: "M220.947 20.882l-10.282 2.057-2.056 10.281-2.057-10.282-10.282-2.056 10.282-2.056 2.057-10.282 2.057 10.282zm0 0",
    className: "cls-2",
    "data-name": "Path 16959",
    transform: "translate(-180.5 -7.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16960",
    d: "M218.89 79.741L208.608 81.8l-1.028 5.141-1.028-5.141-10.282-2.057 10.282-2.056 1.028-5.141 1.028 5.141zm0 0",
    className: "cls-3",
    "data-name": "Path 16960",
    transform: "translate(-180.5 -66.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16961",
    d: "M8.578 117.792a2.059 2.059 0 0 0 .452 1.186l18.289 22.95a1.439 1.439 0 0 0 2.159.1c-.034-.035-.072-.064-.1-.1l-18.288-22.95a2.057 2.057 0 0 1-.452-1.186 2.09 2.09 0 0 1 .85-1.81l6.272-4.62a2.217 2.217 0 0 1 1.09-.418h.013a1.659 1.659 0 0 1 .185-.007h-2.059a1.657 1.657 0 0 0-.185.007h-.014a2.216 2.216 0 0 0-1.09.418l-6.272 4.62a2.09 2.09 0 0 0-.85 1.81zm0 0",
    className: "cls-4",
    "data-name": "Path 16961",
    transform: "translate(-7.882 -102.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16962",
    d: "M8.638 205.7l5.554 6.969 12.74 15.984-1.072.855-12.74-15.982-5.554-6.969zm0 0",
    className: "cls-4",
    "data-name": "Path 16962",
    transform: "translate(-6.955 -189.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16963",
    d: "M40.584 12.352l-2.763-.552-4.091-3.017a2.876 2.876 0 0 0-1.7-.557h-1.712L28.781.549a.686.686 0 0 0-1.344 0L25.9 8.226H9.108a2.879 2.879 0 0 0-1.7.556L1.143 13.4a2.767 2.767 0 0 0-1.114 1.886 2.687 2.687 0 0 0-.014.429c0 .018-.01.033-.01.051s.007.024.008.038a2.755 2.755 0 0 0 .6 1.576l1.709 2.142a.685.685 0 1 0 1.072-.855l-1.71-2.142c-.019-.023-.03-.049-.046-.072H5.78l11.34 19.438L6.81 22.956a.685.685 0 1 0-1.072.855L18.9 40.331a2.115 2.115 0 0 0 1.659.8h.009a2.112 2.112 0 0 0 1.659-.8l18.299-22.953a2.762 2.762 0 0 0-.16-3.638l.216-.044a.686.686 0 0 0 0-1.344zM30.59 9.6h1.44a1.494 1.494 0 0 1 .882.288l1.735 1.28-3.9-.78zm-2.481-5.418l.973 4.867.411 2.057a.685.685 0 0 0 .537.537l6.921 1.382-6.923 1.385a.686.686 0 0 0-.538.538l-1.382 6.921-1.385-6.923a.686.686 0 0 0-.537-.538l-6.921-1.382 6.925-1.386a.686.686 0 0 0 .538-.538l.411-2.057zM8.984 11l2.551 4.084H6.942zm.74-1.4h5.238l-2.619 4.19zm3.427 5.484l2.673-4.273.983 1.31-1.175.234a.686.686 0 0 0 0 1.344l6.923 1.385zm6.732 1.371v19.764l-6.588-19.767zm5.587-6.066l-7.17 1.432L16.627 9.6h9zM1.958 14.508l5.92-4.367-2.318 4.633a.674.674 0 0 0-.069.307H1.5a1.418 1.418 0 0 1 .455-.572zm9.891 1.943l5.978 17.927-10.46-17.926zM24.018 35.89l4.34-7.443a.685.685 0 0 0-1.185-.685l-3.863 6.616 2.7-8.113a.686.686 0 1 0-1.3-.433l-3.456 10.387V16.452h4.373l1.81 9.048a.686.686 0 0 0 1.344 0l1.81-9.048h3.18l-2.6 4.455a.685.685 0 1 0 1.186.686l3-5.141H39.5c-.017.023-.029.049-.047.072zm15.163-21.382a1.417 1.417 0 0 1 .454.572h-5.974l4.954-.991zm0 0",
    className: "cls-5",
    "data-name": "Path 16963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16964",
    d: "M2.746.008a.685.685 0 0 0-.686.685v.685a.686.686 0 0 1-.686.686H.69a.685.685 0 1 0 0 1.371h.685a.685.685 0 0 1 .686.685v.686a.685.685 0 0 0 1.371 0v-.685a.685.685 0 0 1 .685-.685H4.8a.685.685 0 0 0 0-1.371h-.683a.685.685 0 0 1-.685-.686V.693a.686.686 0 0 0-.686-.685zm0 0",
    className: "cls-5",
    "data-name": "Path 16964",
    transform: "translate(0 -.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16965",
    d: "M62.48 409.609a.685.685 0 0 0-.686.685v.686a.685.685 0 0 1-.685.685h-.686a.685.685 0 0 0 0 1.371h.686a.686.686 0 0 1 .685.686v.686a.686.686 0 0 0 1.371 0v-.686a.686.686 0 0 1 .685-.686h.686a.685.685 0 0 0 0-1.371h-.686a.685.685 0 0 1-.685-.685v-.686a.686.686 0 0 0-.685-.685zm0 0",
    className: "cls-5",
    "data-name": "Path 16965",
    transform: "translate(-54.936 -376.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16966",
    d: "M49.008 255.9h-.132a.519.519 0 0 0-.137.028.421.421 0 0 0-.122.046.839.839 0 0 0-.115.075.658.658 0 0 0-.226.725.664.664 0 0 0 .845.466.684.684 0 0 0-.112-1.339zm0 0",
    className: "cls-5",
    "data-name": "Path 16966",
    transform: "translate(-44.366 -235.342)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamond_icon.5cee9ff7388fdd78f53fb7eb8ae598a8.svg";
export { ForwardRef as ReactComponent };